import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    api
      .post("/auth/session", { session_id: sessionId })
      .then((r) => {
        setUser(r.data);
        navigate("/admin", { replace: true, state: { user: r.data } });
      })
      .catch(() => {
        toast.error("Sign-in failed — please try again");
        navigate("/admin", { replace: true });
      });
  }, [location.hash, navigate, setUser]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-cream">
      <p className="font-mono text-xs uppercase tracking-[0.28em] text-clay/60">Signing you in…</p>
    </div>
  );
};

export default AuthCallback;
